define(function (require, exports) {
    'use strict';

    var TimeoutConstant = {
        "beforeLogin" : 15 * 60000,  // *60000 to convert into millisecond 15 * 60000
    }
    
    var time = null;

    // @ngInject
    exports.idleTimeout = function ($timeout) {
        var time;
        this.setTimerConfig= function() {
            var timeout  = TimeoutConstant.beforeLogin;
            this.startTimer(timeout);
        }

        this.startTimer = function(timeout){
            time = $timeout(function(){
                location.reload();
            },timeout);
        }
    
        this.resetTime = function() {
            $timeout.cancel(time);
            this.setTimerConfig();
        }

        this.setTimerConfig()
    };
});


// WEBPACK FOOTER //
// ./scripts/services/idle-timeout.js